import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'searchable-select',
    templateUrl: './searchable-select.component.html',
     styleUrls: ['./searchable-select.component.scss'],
})
export class SearchableSelectComponent<T extends Record<string, any>> implements OnInit, OnChanges {
    @Input() label!: string;
    @Input() customWidth: string;
    @Input() options:  T[] | null = [];
    @Input() valueKey: string = '';
    @Input() labelKey: string = '';
    @Input() value!: string | number;
    @Input() disabled: boolean = false;

    @Output() valueChange = new EventEmitter<string>();

    public searchControl = new FormControl('');
    public filteredOptions$!: Observable<T[] | []>;

    public ngOnInit(): void {
        this.filteredOptions$ = this.searchControl.valueChanges.pipe(
            startWith(''),
            map(search => this.filterOptions(this.options, search))
        );
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['options'] && this.options) {
            this.searchControl.setValue(this.searchControl.value || '');
        }
    }

    public filterOptions(options: T[], search: string) {
        return (options || []).filter(opt => {
            const label = this.labelKey ? String(opt[this.labelKey]) : String(opt);
            return label?.toLowerCase().includes(search.toLowerCase());
        });
    }

    public onClosed(){
        this.searchControl.setValue('')
    }

    public getDisplay(opt: T): string {
        if (this.labelKey) return String(opt[this.labelKey]);
        return String(opt);
    }
}